import {
    API_RESPONSE_ERROR,
    API_RESPONSE_SUCCESS, CHECK_CPF_CUSTOMER,
    CREATE_ASSOCIATES,
    DELETE_ASSOCIATES,
    GET_ASSOCIATES,
    GET_ORDER_ASSOCIATES,
    GET_SUMMARY_ASSOCIATES,
    UPDATE_ASSOCIATES,
} from "./actionType";

const INIT_STATE = {
    associates: null,
    error: {},
    success: "",
    loading: true,
    total: null,
    active: null,
    inactive: null,
    today: null,
};

const Associates = (state = INIT_STATE, action) => {
    switch (action.type) {
        case API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case GET_ASSOCIATES:
                    return {
                        ...state,
                        associates: action.payload.data.data,
                        success: "",
                        error: {},
                    };
                case GET_ORDER_ASSOCIATES:
                    return {
                        ...state,
                        associates: action.payload.data,
                        success: "",
                        error: {},
                        loading: false,
                    };
                case GET_SUMMARY_ASSOCIATES:
                    return {
                        ...state,
                        total: action.payload.data.total,
                        active: action.payload.data.active,
                        inactive: action.payload.data.inactive,
                        today: action.payload.data.today,
                    };
                case CREATE_ASSOCIATES:
                    return {
                        ...state,
                        success: "Sucessfully created associates",
                        error: {},
                    };
                case CHECK_CPF_CUSTOMER: {
                    return {
                        ...state,
                        success: "Successfully check proposal",
                        error: {},
                    };
                }
                case UPDATE_ASSOCIATES:
                    return {
                        ...state,
                        success: "Sucessfully updated associates",
                        error: {},
                    };
                case DELETE_ASSOCIATES:
                    return {
                        ...state,
                        success: "Sucessfully delete associates",
                        error: {},
                    };
                default:
                    return {...state};
            }
        case API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case GET_ASSOCIATES:
                    return {
                        ...state,
                        success: "",
                        error: action.payload.error,
                    };
                case GET_SUMMARY_ASSOCIATES:
                    return {
                        ...state,
                        success: "",
                        error: action.payload.error,
                    };
                case GET_ORDER_ASSOCIATES:
                    return {
                        ...state,
                        success: "",
                        error: action.payload.error,
                        loading: false,
                    };
                case CREATE_ASSOCIATES:
                    return {
                        ...state,
                        success: "",
                        error: action.payload.error,
                    };
                case UPDATE_ASSOCIATES:
                    return {
                        ...state,
                        success: "",
                        error: action.payload.error,
                    };
                case DELETE_ASSOCIATES:
                    return {
                        ...state,
                        success: "",
                        error: action.payload.error,
                    };
                default:
                    return {...state};
            }
        case GET_ASSOCIATES: {
            return {
                ...state,
            };
        }
        case GET_SUMMARY_ASSOCIATES: {
            return {
                ...state,
            };
        }
        case GET_ORDER_ASSOCIATES: {
            return {
                ...state,
                loading: true,
            };
        }
        case CREATE_ASSOCIATES: {
            return {
                ...state,
            };
        }
        case UPDATE_ASSOCIATES: {
            return {
                ...state,
            };
        }
        case DELETE_ASSOCIATES: {
            return {
                ...state,
            };
        }
        case CHECK_CPF_CUSTOMER: {
            return {
                ...state,
                success: "",
                error: action.payload.error,
            };
        }
        default:
            return {...state};
    }
};

export default Associates;
